/**
 * Wishlist Authentication Handler
 * 
 * This script checks if a user is authenticated when clicking on the wishlist button.
 * If not authenticated, it triggers the Sign In/Create Account modal instead of the wishlist action.
 */

(function() {
  // Function to check if customer is logged in
  function isCustomerLoggedIn() {
    return window.swymCustomerId !== null && window.swymCustomerId !== undefined;
  }
  
  // Function to open sign in modal
  function openSignInModal() {
    // Redirect to the login page with return_to parameter to come back after login
    const currentUrl = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.href = '/account/login?return_to=' + currentUrl;
  }
  
  // Function to handle wishlist button click
  function handleWishlistButtonClick(event) {
    if (!isCustomerLoggedIn()) {
      event.preventDefault();
      event.stopPropagation();
      openSignInModal();
      return false;
    }
    // If logged in, allow the default Swym behavior to continue
  }
  
  // Add event listener to all wishlist buttons
  function addWishlistButtonListeners() {
    const wishlistButtons = document.querySelectorAll('.wishlist-btn.swym-add-to-wishlist-view-product, .swym-button.swym-add-to-wishlist-view-product, .button-wish.wishlist-btn.custom-notify-me-btn, .swym-button.swym-add-to-wishlist-view-product.swym-inject.swym-loaded');
    
    wishlistButtons.forEach(button => {
      // Skip buttons that already have our listener
      if (button.hasAttribute('data-auth-listener')) {
        return;
      }
      
      // Add our listener
      button.setAttribute('data-auth-listener', 'true');
      button.addEventListener('click', handleWishlistButtonClick, true);
    });
  }
  
  // Performance: Throttle function to reduce callback frequency
  function throttle(func, delay) {
    let timeoutId;
    return function(...args) {
      if (!timeoutId) {
        timeoutId = setTimeout(() => {
          func.apply(this, args);
          timeoutId = null;
        }, delay);
      }
    };
  }
  
  // Initialize when DOM is ready
  function initialize() {
    addWishlistButtonListeners();
    
    // Performance: Throttled MutationObserver to reduce CPU usage
    const throttledCheck = throttle(function() {
      addWishlistButtonListeners();
    }, 200);
    
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          shouldCheck = true;
        }
      });
      
      if (shouldCheck) {
        throttledCheck();
      }
    });
    
    // Start observing the document for added nodes
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  // If the document is already loaded, initialize immediately
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(initialize, 1);
  } else {
    document.addEventListener('DOMContentLoaded', initialize);
  }
  
  // Register with Swym callbacks if available
  if (window.SwymCallbacks) {
    window.SwymCallbacks.push(function() {
      addWishlistButtonListeners();
    });
  }
})();
